export default `
fragment ParagraphAccessMenu on ParagraphAccessMenu {
  id
  uuid
  entityBundle
}
`